const parse = url => {
  const a = document.createElement('a');
  a.href = url;
  return a;
};

export const isValidRedirectUrl = redirectUrl =>
  redirectUrl
  && /(.+\.)?(comcast\.com|comcast\.net|xfinity\.com)$/.test(parse(redirectUrl).hostname);
